export const accentColors = {
  accentOne: '#FFB16A',
  accentTwo: '#DEE159',
  accentThree: '#A3BBCF',
  accentFour: '#A19FFF',
  accentFive: '#9DE7DE',
  accentSix: '#F5B2F2',
} as const;
